import api from "@/lib/api";

// Read one scanned page on the server with the fast reader (about 3x quicker per page); dropped pages are retried.
export async function ocrPage(image_base64, tries = 3) {
  for (let i = 1; ; i++) {
    try {
      const { data } = await api.post("/ocr/page", { image_base64, fast: true }, { timeout: 65000 });
      return data.text || "";
    } catch (err) {
      const s = err.response?.status;
      const retryable = !s || s >= 500 || s === 429;
      if (!retryable) throw err;
      if (i >= tries) throw new Error(`could not be read after ${tries} tries - upload this file again`);
      await new Promise((r) => setTimeout(r, 1000 * i));
    }
  }
}
